import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Header from './header/';
import Navigation from './navigation/';
import AnimationPic from './animationPic/';
// import StockPlate from './stockPlate/';
// import StockSearch from './stockSearch/';
import JumpLink from './jumpLink/';
import Content from './content';
// import HotSpots from './hotSpots';
import School from './school';
import BottomFooter from './footer/';
import Cooperation from './cooperation/';
import QrCode from './qrCode/';
import BottomAffix from './bottomAffix/';
// import { getAllMarket, getMarketVarieties } from '@src/services/api';

// import StockList from '@/src/pc/components/stockList';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        allMarket: [],
        marketVarieties: {},
    };
    timer = null;
    getData = async () => {
        // const marketResult = await getAllMarket();

        // this.setState({
        //     allMarket: marketResult,
        // });
    };
    async componentDidMount() {

        // this.getData();

        // const varietiesResult = await getMarketVarieties();

        // this.setState({
        //     marketVarieties: varietiesResult,
        // });

        // this.timer = setInterval(() => {
        //     this.getData();
        // }, 1000 * 10);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { allMarket, marketVarieties } = this.state;

        console.log('content', content);

        const headerData = {
            nav: content.nav,
            search: content.search,
            topAd: content.topAd,
            logo: content.logo,
            logoAd: content.logoAd,
        };
        const navigationData = {
            nav: content.navigation,
            subNav: content.subNavigation,
        };
        // const stockPlate = content.stockPlate;
        const animationPicAd = content.animationPicAd;
        const jumpLink = content.jumpLink;
        const contentData = {
            leftContent: {
                headline: content.headline,
                broadcast: content.broadcast,
                newsLive: {
                    newsLiveTab: content.newsLiveTab,
                    newsLiveTabLink: content.newsLiveTabLink,
                    stockNews: content.stockNews,
                    liveLogo: content.liveLogo,
                    zqywClient: content.zqywClient,
                },
                news: {
                    newsTab: content.newsTab,
                    news: content.news,
                },
                answer: {
                    answerTab: content.answerTab,
                    answerSubTab: content.answerSubTab,
                    answerList: content.answerList,
                    niuRenJiePan: content.niuRenJiePan,
                },
                leftAsideAd: content.leftAsideAd,
            },
            bannerPic: content.bannerPic,
            bannerPicAd: content.bannerPicAd,
            middleContent: {
                cattleStocksTitle: content.cattleStocksTitle,
                rankTitle: content.rankTitle,
                fundsFlowTitle: content.fundsFlowTitle,
                customStocksTitle: content.customStocksTitle,
                QaTitle: content.QATitle,
                finance: content.finance,
                financeList: content.financeList,
                allMarket, 
                marketVarieties 
            },
            marketlens: content.marketlens,
            rightContent: {
                subjectTitle: content.subjectTitle,
                subject: content.subject,
                marketTitle: content.marketTitle,
                market: content.market,
                courier: {
                    courierTitle: content.courierTitle,
                    courier: content.courier,
                },
                playItem: content.playItem,
                rightSideAd0: content.rightSideAd0,
                rightSideAd1: content.rightSideAd1,
                linkList: content.linkList,
                dayStockTitle: content.dayStockTitle,
                dayStock: content.dayStock,
            },
        };
        const hotSpotsData = {
            hotSpotsTitle: content.hotSpotsTitle,
            hotSpotsSubTitle1: content.hotSpotsSubTitle1,
            marketAnalysis: content.marketAnalysis,
            hotSpotsSubTitle2: content.hotSpotsSubTitle2,
            hotPlate: content.hotPlate,
            industryTitle: content.industryTitle,
            industry: content.industry,
            hyin: content.hyin,
            hyout: content.hyout,
            gnin: content.gnin,
            gnout: content.gnout,
            singleStockTitle: content.singleStockTitle,
            marketRadarTabs: content.marketRadarTabs,
            marketRadar: content.marketRadar,
            trackTabs: content.trackTabs,
            track: content.track,
            fiveDaysTabs: content.fiveDaysTabs,
            fiveDaysBuy: content.fiveDaysBuy,
            fiveDaysSell: content.fiveDaysSell,
            hotSpotsAd: content.hotSpotsAd,
            cprdData: content.cprdData,
        };
        const schoolData = {
            schoolTitle: content.schoolTitle,
            schoolSubTitle1: content.schoolSubTitle1,
            logs: content.logs,
            schoolSubTitle2: content.schoolSubTitle2,
            school: content.school,
            starAnalystTitle: content.starAnalystTitle,
            starAnalyst: content.starAnalyst,
            starSrank: content.starSrank,
            starMrank: content.starMrank,
            starLrank: content.starLrank,
            stockPickingTitle: content.stockPickingTitle,
            stockpool: content.stockpool,
            stockpoolData: content.stockpoolData,
            chgpctest: content.chgpctest,
            chgpctestData: content.chgpctestData,
            levelup: content.levelup,
            levelupData: content.levelupData,
            firstfocus: content.firstfocus,
            firstfocusData: content.firstfocusData,
            focusest: content.focusest,
            focusestData: content.focusestData,
            schoolAd: content.schoolAd,
            gsxtData: content.gsxtData,
        };

        const footerData = {
            bottomAd: content.bottomAd,
            footer: content.footer,
        };
        const cooperation = content.cooperation;
        const qrCode = content.qrCode;

        return (
            <div className={styles.col_box}>
                <Header content={headerData} />
                <div className={styles.content}>
                    <div className={styles.col}>
                        <Navigation content={navigationData} />
                        <NoSSR>
                            <AnimationPic content={animationPicAd} />
                            {/* 股票banner */}
                             {/* <StockList allMarket={allMarket} /> */}
                        </NoSSR>
                        {/* <StockPlate content={stockPlate} /> */}
                        {/* <div className={styles.search_box}> */}
                            {/* <StockSearch /> */}
                            {/* <Chip
                                id="20042"
                                type="struct"
                                title="导航跳转链接"
                                groupName="导航栏"
                                position="relative"
                                content={jumpLink}>
                                <JumpLink />
                            </Chip> */}
                            {/* <div className="clear" /> */}
                        {/* </div> */}
                    </div>
                    <div className={styles.space20} />
                    <Content content={contentData} />
                    <div className={styles.space30} />
                    {/* <HotSpots content={hotSpotsData} />
                    <div className={styles.space30} /> */}
                    {/* <School content={schoolData} /> */}
                </div>
                <div className={styles.cooperation}>
                    <NoSSR>
                        <Chip
                            id="10074"
                            type="static"
                            title="底部合作链接"
                            groupName="底部合作链接"
                            content={cooperation}
                            position="relative">
                            <Cooperation />
                        </Chip>
                    </NoSSR>
                </div>
                <BottomFooter content={footerData} />
                <div className={styles.space25} />
                <NoSSR>
                    <Chip
                        id="20079"
                        type="struct"
                        title="二维码"
                        groupName="二维码"
                        position="relative"
                        content={qrCode}>
                        <QrCode />
                    </Chip>
                    <BottomAffix />
                </NoSSR>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default Layout;
